import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';
import { Backdrop, Button, Card, CardContent, CircularProgress, Grid, ListItem, TextField, Box, Badge } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { getUser,getUserRole } from 'src/utils/Common';
import AlertAndLoading from 'src/components/AlertAndLoading';
import axios from 'src/utils/axios';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const CompressMaterial = require('compress.js');
const compressMaterial = new CompressMaterial();

const useStyles = makeStyles((theme) => ({
  divCenter: {
    textAlign: "center"
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  div: {
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%',
    color: 'red'
  },
  div2: {
    fontSize: '12px',
    width: '100%'
  },
  img: {
    width: '100%',
    maxWidth: '600px'
  }
}));

function MuadilFile({muadilId,handleOpenFile,handleCloseFile,readOnly}) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const SessionUser = getUser();

  const [muadilIds,setMuadilIds] = React.useState(muadilId);
  const [showFile, setShowFile] = React.useState(false);
  const [uploadFilePopUp, setUploadFilePopUp] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null)
  const [fileList, setFileList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [selectedFileType, setSelectedFileType] = React.useState(null);
  const [uyari, setUyari] = React.useState(false);
  const [openFileCount, setOpenFileCount] = React.useState(0);
  const [renk, setRenk] = React.useState('black');

  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });
  const [responseMessage, setresponseMessage] = React.useState('');
  const [admin,setAdmin] = React.useState(false);
  const Role = getUserRole().RoleId;
 

  useEffect(() => {
    if(Role?.filter(i => i.ROLE_ID == 14).length > 0){
      setAdmin(true)
    }
  }, []); 

  useEffect(() => {
    getOpenFile();
  }, [dispatch]);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const getOpenFile = () => {
/*     axios.get("/OpenFileCount/" + muadilId, {
      responseType: 'arrayBuffer'
    }).then(response => {
      setOpenFileCount(response.data)
    }); */
    setOpenFileCount(1)
    getReceiptFiles()
  }

  const getReceiptFiles = () => {
    setLoading(true)
    if (!muadilIds) {
      return;
    }
    var images = []
    axios.get("/GetMuadilFiles/" + muadilIds, {
      responseType: 'arrayBuffer'
    }).then(response => {
      response.data.forEach(element => {
        const fileData = {
          fileURL: `data:${element.File.ContentType};base64,${element.File.FileContents}`,
          fileName:  element.File.FileDownloadName + ' - ' + element.FileCreateUser,
          fileId: element.FileId,
          fileCreateUserId: element.FileCreateUserId,
        }

        images.push(fileData)
      });
      setFileList(images)
      setLoading(false)
    });
    setLoading(false)
  }

  function uploadFiles(filedata) {
    setLoading(true)
    axios.post("/UploadMuadilFile", filedata, {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      getOpenFile();
      setSelectedFileType(null);
      setLoading(false)
    }).catch(err => {
      setresponseMessage({
        ErrorCode: 0,
        ErrorDescription: err.response.data,
      });
      setUyari(true);
      setSelectedFileType(null);
      setLoading(false)
      return
    });
  }

  const handleDeleteSureClick = (fileId, fileCreateUserId) => {
    if (fileCreateUserId !== SessionUser.UserId.toString() && !admin) {
      InfoAlert('Sadece eklediğiniz dosyaları silebilirsiniz!...', 'error', 'Hata')
      return
    }
    handleCloseFile();
    confirmAlert({
      message: ('Silmek istediğinizden emin misiniz?'),
      buttons: [
        {
          label: ('Evet'),
          onClick: () => handleDeleteClick(fileId)
        },
        {
          label: ('Hayır'),
          onClick: () => { handleOpenFile() }
        }
      ]
    });
  }

  const handleDeleteClick = (fileId) => {
    
    const Filecount = fileList.filter(obj => obj.FileTypeId === 1).length;
    setLoading(true)
    axios.get("/DeleteMuadilFile/" + fileId, {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      handleOpenFile();
      getOpenFile();
      setLoading(false)
    });
    
    
  }


  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    })
    setUyari(true);
    return
  }

  async function base64Reader(file) {
    const result_base64 = await new Promise(resolve => {
      const fileReader = new FileReader();
      fileReader.onload = e => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64.split(',')[1] || '';
  }

  const handleChangeStatus = () => { };
  const handleSubmitImage = async (files, allFiles) => {
    setLoading(true)
    for (let i = 0; i < files.length; i++) {
      const fileMaterial = files[i].file;
      const metaMaterial = files[i].meta;
      let base64ResultMaterial = '';
      if (metaMaterial.type.indexOf('image') !== -1) {
        const resizedImageMaterial = await compressMaterial.compress(
          [fileMaterial],
          {
            quality: 1, // the quality of the image, max is 1,
            maxWidth: 1920, // the max width of the output image, defaults to 1920px
            maxHeight: 1920, // the max height of the output image, defaults to 1920px
            resize: true // defaults to true, set false if you do not want to resize the image width and height
          }
        );
        const imgMaterial = resizedImageMaterial[0];
        base64ResultMaterial = imgMaterial.data;
      } else {
        base64ResultMaterial = await base64Reader(fileMaterial);
      }
      const data = {
        FileName: metaMaterial.name,
        FileType: metaMaterial.type,
        MuadilId: muadilIds,
        FileData: base64ResultMaterial,
        CreateUser: SessionUser.UserId
      }
      
      
        uploadFiles(data)
        allFiles.forEach(f => f.remove())
        setLoading(false)
        setUploadFilePopUp(false)
      
    }
  };

  const setNewWindowOpen = (row) => {
    if (row?.contentType?.includes('image')) {
      var image = new Image();
      image.src = row.fileURL;
      image.style.cssText = 'max-width: 1000px; max-height: 700px;';
      var w = window.open("");
      w.document.write(image.outerHTML);
      w.document.title = row.fileName;
      w.document.close();

    } else {
      const pdfWindow = window.open("");
      pdfWindow.document.write(
        `<iframe width='100%' height='100%' src='${encodeURI(
          row.fileURL
        )}''></iframe>`
      );
      pdfWindow.document.title = row.fileName;
      pdfWindow.document.close();
    }
  }

  function HandleChangeColorClick(Color) {
    setRenk({ ...renk, [Color]: 'purple' });
  }

  function HandleChangeColorResetClick() {
    setRenk('black');
  }


  return (<>
  
  <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
  
    <Card sx={{ border: 1, borderRadius: 2, borderColor: 'grey.500' }}>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} loading={loading} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography className={classes.div} variant="subtitle1">
              Dosya Bilgileri
            </Typography>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={2}>
            <Tooltip title="Dosya Ekle">
              <IconButton
                className={classes.action}
                style={{ color: '#424242' }}
                key="close"
                onClick={() => setUploadFilePopUp(true)}
                disabled = {readOnly}
              >
                <AddPhotoAlternateIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={1}></Grid>


          <Grid item xs={8}>

          <List>
                {fileList.map((row, index) => (
                  <ListItem key={index}>
                    <ListItemButton
                      style={{ display: 'flex', cursor: 'pointer' }}
                    >
                      <ListItemIcon>
                      {!readOnly && (
                        <DeleteIcon onClick={() => { handleDeleteSureClick(row.fileId, row.fileCreateUserId) }} style={{ color: '#FF9800' }} />
                    )}
                        <FolderIcon style={{ color: '#424242' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={<Typography type="body2" className={classes.div2}>{row.fileName}</Typography>}
                        style={{
                          color: renk[row.fileId] || 'black',
                        }}
                        onClick={() => {
                          console.log(row)
                          setNewWindowOpen(row);
                          // setShowFile(true)
                          // setSelectedFile(row)
                          HandleChangeColorClick(row.fileId);
                        }}
                      />
                      <ListItemText
                        primary={row.ContentType}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>

          </Grid>
        </Grid>
        
      </CardContent>
      <Dialog
        fullScreen
        open={showFile}
        onClose={() => setShowFile(false)}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setShowFile(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Dosya
            </Typography>
            <Button autoFocus color="inherit" onClick={() => setShowFile(false)}>
              Kapat
            </Button>
          </Toolbar>
        </AppBar>
        {selectedFile?.contentType.includes('image') ?
          <Grid container
            alignItems="center"
            justify="center">
            <Grid item sm={12} alignItems="center"
              justify="center" textAlign="center">
              <img
                src={selectedFile.fileURL}
                srcSet={selectedFile.fileURL}
                alt={selectedFile.fileURL}
                loading="lazy"
                style={{ objectFit: 'contain', padding: 5, maxWidth: '100%', maxHeight: 50 }}
              />
            </Grid>
          </Grid>
          :
          (<iframe width='100%' height='100%' src={selectedFile?.fileURL}></iframe>)

        }
      </Dialog>
      <Dialog
        open={uploadFilePopUp}
        onClose={() => setUploadFilePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ width: '100%', color: 'red', fontWeight: 'bold' }} >Dosya Yükle</DialogTitle>
        <DialogContent>

          <Grid container spacing={2} style={{ paddingTop: 20 }}>
            <Grid item xs={12} md={12}>
              <Dropzone
                onChangeStatus={handleChangeStatus}
                onSubmit={handleSubmitImage}
                styles={{
                  dropzone: { minHeight: 200, maxHeight: 250 }
                }}
                submitButtonContent="Yükle"
                minSize={0}
                maxSize={8072000}
                inputWithFilesContent={files => `${5 - files.length} ekle`}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={() => { setUploadFilePopUp(false); setSelectedFileType(null) }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </DialogActions>
      </Dialog>
    </Card >
    </>
  );
}

export default MuadilFile;